<script setup lang="ts">
import LogoComponent from '../sidebar/Logo.vue'
import LogoWordsOnly from '../sidebar/LogoWordsOnly.vue'
import ThemeSelector from './ThemeSelector.vue'
import { AppActionType, appHeaderCSS, menuItemIds } from '@/models/'
import { useNavigationStore } from '@/state/'
import type { IConfig } from '@/config'
import type { TAppActionEmit } from '@/models'

interface TProps {
  loading: boolean
  isCollapsed: boolean
  isEditing: boolean
  config: IConfig
  // in vue/nuxt we handle this with emits:
  //action: <T = unknown>(params: TAppActionParams<T>) => void // in vue we do this via emits
}

withDefaults(defineProps<TProps>(), {
  loading: false,
  isEditing: false,
  enableThemeEditorPopup: false,
})

const emits = defineEmits<TAppActionEmit>()
const navigationStore = useNavigationStore()
const translate = (_: any) => 'Open Sidebar'

const onToggleMobileSidebarClicked = () => {
  emits('action', {
    type: AppActionType.toggleMobileSidebarOpen,
  })
}

const onToggleDesktopSidebarCollapsed = () => {
  emits('action', {
    type: AppActionType.toggleSidebarCollapsed,
  })
}
</script>

<template>
  <div data-testid="app-header" :class="appHeaderCSS.wrapper">
    <div :class="appHeaderCSS.innerWrapper1">
      <button
        data-testid="btn-menu"
        type="button"
        class="px-4 focus:outline-none lg:hidden"
        @click.stop="onToggleMobileSidebarClicked"
      >
        <span class="sr-only">{{ translate('labels.openSidebar') }}</span>
        <LogoComponent :brandConfig="config.brand" :className="appHeaderCSS.logo" aria-hidden="true" />
      </button>
    </div>

    <div :class="appHeaderCSS.innerWrapper2">
      <div class="flex-1 hidden sm:flex gap-4 h-full items-center">
        <div class="flex items-center gap-2 whitespace-nowrap">
          <div v-if="isCollapsed" class="flex cursor-pointer" @click="onToggleDesktopSidebarCollapsed">
            <LogoWordsOnly :brandConfig="config.brand" :className="appHeaderCSS.logoWordsOnly" />
          </div>
          <a href="/about" rel="noopener noreferer">
            <h1 class="cursor-pointer font-bold text-primary hover:text-primary">
              {{ config.nuxtDashboardPro.productName }}
            </h1>
          </a>
        </div>
      </div>
      <div class="flex flex-row items-center gap-x-1 sm:gap-x-0">
        <!-- themes -->
        <ThemeSelector />
      </div>
    </div>
  </div>
</template>
